import { z } from 'zod';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const invitationCreateSchema = z.object({
  email: z.string().email('Invalid email address'),
  firstName: z.string().max(50, 'First name must be less than 50 characters').optional(),
  lastName: z.string().max(50, 'Last name must be less than 50 characters').optional(),
  role: z.enum(['admin', 'staff'], {
    errorMap: () => ({ message: 'Role must be either admin or staff' })
  }),
  isProvider: z.boolean().optional(),
  personalMessage: z.string().max(500, 'Message must be less than 500 characters').optional()
});

export const invitationAcceptSchema = z.object({
  firstName: z.string().min(1, 'First name is required').max(50),
  lastName: z.string().min(1, 'Last name is required').max(50),
  phone: z.string()
    .optional()
    .or(z.literal(''))
    .refine(
      (val) => !val || val === '' || isValidPhoneNumber(val),
      'Please enter a valid phone number for the selected country'
    ),
  password: z.string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
    .regex(/[0-9]/, 'Password must contain at least one number'),
  passwordConfirmation: z.string().min(1, 'Please confirm your password')
}).refine((data) => data.password === data.passwordConfirmation, {
  message: 'Passwords do not match',
  path: ['passwordConfirmation']
});

export type InvitationCreateFormData = z.infer<typeof invitationCreateSchema>;
export type InvitationAcceptFormData = z.infer<typeof invitationAcceptSchema>;
